import { useState } from "react";
import { IPersonBadge } from "../../../../../../common/types";
import PrintSettingsCache from "../../../../../printSettings/cache/PrintSettingsCache";
import { PrintMethods } from "../../../../../../common/enums";
import { SNACKBAR_VARIANTS } from "../../../../../../common/constants";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { useCompanyBadgeActions } from "./useCompanyBadgeActions";

export const usePrintDialog = () => {
  const [isPrintDialogOpened, setPrintDialogOpened] = useState(false);
  const [isCameraOverrideDialogOpened, setCameraOverridePrintDialogOpened] = useState(false);
  const [badgesToPrint, setBadgesToPrint] = useState<IPersonBadge[]>([]);
  const { t } = useTranslation("common");
  const { enqueueSnackbar } = useSnackbar();
  const { printBadges } = useCompanyBadgeActions();

  const closePrintDialog = () => {
    setPrintDialogOpened(false);
  };

  const openPrintDialog = () => {
    const cachedSettings = PrintSettingsCache.get();
    if (cachedSettings.printMethod !== PrintMethods.PRINT_SERVER) {
      enqueueSnackbar(<b>{t("errors.configurePrintServer")}</b>, SNACKBAR_VARIANTS.error);
      return;
    }
    setPrintDialogOpened(true);
  };

  const handleStaffOverride = async () => {
    setCameraOverridePrintDialogOpened(false);
    await printBadges(badgesToPrint);
  };

  const handleCloseOverrideCameraDialog = () => {
    setCameraOverridePrintDialogOpened(false);
  };

  const handleOpenOverrideCameraDialog = () => {
    setCameraOverridePrintDialogOpened(true);
  };

  return {
    isPrintDialogOpened,
    closePrintDialog,
    openPrintDialog,
    badgesToPrint,
    setBadgesToPrint,
    isCameraOverrideDialogOpened,
    handleCloseOverrideCameraDialog,
    handleOpenOverrideCameraDialog,
    setCameraOverridePrintDialogOpened,
    handleStaffOverride
  };
};
